"use client";

import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Chip from "@/components/ui/chip";
import { cn } from "@/lib/cn";

const filterGroups: { label: string; values: string[] }[] = [
  { label: "Size", values: ["Small", "Medium", "Large", "Extra large"] },
  { label: "Finish", values: ["Matt", "Polished", "Honed", "Structured"] },
  { label: "Colour", values: ["Warm", "Cool", "Natural", "Bold"] },
  { label: "Price", values: ["Under £20", "£20 – £50", "£50 – £100", "£100+"] },
  { label: "Availability", values: ["In stock", "Made to order"] },
];

export default function CollectionFilters() {
  const [open, setOpen] = useState<Set<string>>(new Set());

  const toggle = (label: string) => {
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      return next;
    });
  };

  return (
    <aside className="flex flex-col">
      <div className="text-xs uppercase tracking-[0.18em] font-semibold text-[color:var(--color-text)] pb-3 border-b border-[color:var(--color-border)]">
        Filters
      </div>
      <ul className="flex flex-col">
        {filterGroups.map((g) => {
          const isOpen = open.has(g.label);
          return (
            <li key={g.label} className="border-b border-[color:var(--color-border)]">
              <button
                type="button"
                onClick={() => toggle(g.label)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between py-3.5 text-left text-sm font-semibold text-[color:var(--color-text)] hover:text-[color:var(--color-primary)]"
              >
                <span>{g.label}</span>
                <span
                  className={cn(
                    "inline-flex h-6 w-6 items-center justify-center rounded-full border border-[color:var(--color-border-strong)] text-[color:var(--color-text)] transition-colors",
                    isOpen && "bg-[color:var(--color-text)] text-white border-[color:var(--color-text)]",
                  )}
                >
                  {isOpen ? <Minus size={13} /> : <Plus size={13} />}
                </span>
              </button>
              {isOpen && (
                <ul className="flex flex-wrap gap-2 pb-4">
                  {g.values.map((v) => (
                    <li key={`${g.label}-${v}`}>
                      <Chip as="span">{v}</Chip>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
